import React from 'react';
import {Layout, Button} from 'antd';
import {MenuUnfoldOutlined, MenuFoldOutlined} from '@ant-design/icons';
import {useDispatch, useSelector} from 'react-redux';
import {toggleSidebar} from '../store/reducers/sidebarReducer';
import AfSidebarMenu from './AfSidebarMenu';
import theme from '../theme';
import {useMediaQuery} from 'react-responsive';
import packageJson from '../../package.json';

const {Sider} = Layout;

const AfSideBar = () => {
    // Check if is in mobile or not and get auth data
    const isMobile = useMediaQuery({maxWidth: 768});

    // Get dispatch to collapse sidebar menu in all app
    const dispatch = useDispatch();
    const collapsed = useSelector((state) => state.sidebar.collapsed);

    return !isMobile ? (
        <Sider
            collapsible
            collapsed={collapsed}
            trigger={null}
            style={{
                marginTop: '64px',
                background: theme.colors.secondary,
                color: theme.colors.card,
                padding: '10px'
            }}
        >
            <Button
                type="text"
                onClick={() => dispatch(toggleSidebar())}
                icon={collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                style={{
                    color: theme.colors.card,
                    fontSize: '18px',
                    width: '100%',
                    textAlign: 'left',
                    marginBottom: '10px'
                }}
            />
            
            <AfSidebarMenu/>
            
            <div style={{
                position: 'absolute',
                bottom: '20px',
                left: collapsed ? '50%' : '20px',
                transform: collapsed ? 'translateX(-50%)' : 'none',
                color: '#9ca3af',
                fontSize: '12px',
                whiteSpace: 'nowrap'
            }}>
                v{packageJson.version}
            </div>
        </Sider>
    ) : <></>;
};

export default AfSideBar;
